import React from 'react'
import { pathOr } from 'ramda'
import { useAuth, UserPermission, ActionTypes } from '@/auth'
import { isNil } from '@/utils/webHelper'

export default function useAuthActType(actType?: number) {
  const { user } = useAuth()

  const authByActType = React.useMemo(() => {
    if (actType) {
      return pathOr({}, ['authByActType', actType], user) as UserPermission
    }
  }, [actType, user])

  const checkIsActionEnable = React.useCallback(
    (action: ActionTypes) => {
      if (isNil(authByActType)) {
        return undefined
      }

      return authByActType && authByActType[action]
    },
    [authByActType]
  )

  return { authByActType, checkIsActionEnable }
}
